import styled from "styled-components";

export const UserMenuItemsTitleBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 0.5rem 0;
  font-size: 1.4rem;
  color: ${props => props.theme.colors.textLight};
`;
